import { createStore } from 'vuex'
import { auth, db} from '@/firebase/gfbconf'
import axios from "axios"


export default createStore({
  state: {
    apiLink: "production",
    apiKey: "",
    userId: "",
    userKey: "",
    notification: {
      show: false,
      head: "",
      subheader: "",
      success: true,
    },
    user: null,
    userData: null,
    authIsReady: false,
    globalLoader: {
      show: true,
      head: "Ładowanie..",
      subheader: "Nie zamykaj tego okna."
    }
  },
  mutations: {
    setNotification(state, notification)
    {
      state.notification = notification;
      setTimeout(()=>
      {
        state.notification = {
          show: false,
          head: "",
          subheader: "",
          success: true,
        }
      },3000)
    },
    setUrl(state, url)
    {
      state.url = url
    },
    // Set user to Vuex store
    setUser(state, userData)
    {
      state.user = userData;
    },
    updateInternetConnectionStatus(state, status)
    {
      state.internetConnection = status;
    },
    setUserCredentials(state, userData)
    {
      state.userData = userData;
    },
    setAuthIsReady(state,payload)
    {
      state.authIsReady = payload;
    },
    // reset global loader
    resetGlobalLoader(state)
    {
      state.globalLoader = {
        show: false,
        head: "Ładowanie..",
        subheader: "Nie zamykaj tego okna."
      }
    },
    setGlobalLoader(state,context)
    {
      state.globalLoader = context;
    },

  },
  actions: {
    // login new user
    async login(context,payload)
    {
      try {
        const signIn = await auth.signInWithEmailAndPassword(payload.email, payload.password);
        if (signIn) {
          context.commit('setGlobalLoader',{
            show: true,
            head: "Sprawdzanie twoich danych..",
            subheader: `Nie zamykaj okna.`,
            success: false
        });
        let claims = (await signIn.user.getIdTokenResult()).claims
          const res = await axios.post(`${context.state.apiLink}/users/get`,{}, {
            headers: {
              "apikey": context.state.apiKey,
              "userkey": claims.userKey,
              "userid": claims.userId
            }
          })
          context.state.userId = claims.userId
          context.state.userKey = claims.userKey
  
          if(res.data.status === 'SUCCESS') {
            if(res.data.userData.permissions.admin) {
              context.commit('setUserCredentials', res.data.userData);
              context.commit('setUser', signIn.user);
            } else {
              throw new Error("User do not have permissions")
            }
          } else {
            context.commit('setGlobalLoader',{
                show: false,
                head: "Sprawdzanie twoich danych..",
                subheader: `Nie zamykaj okna.`,
                success: false
            });
            throw new Error("Something went wrong when getting userData")
          }
        } else {
          context.commit('setGlobalLoader',{
            show: false,
            head: "Sprawdzanie twoich danych..",
            subheader: `Nie zamykaj okna.`,
            success: false
          });
          throw new Error("Could not complete login action.")
        }
      } catch (error) {
        context.commit('setGlobalLoader',{
          show: false,
          head: "Sprawdzanie twoich danych..",
          subheader: `Nie zamykaj okna.`,
          success: false
      });
      throw new Error("Could not complete login action.")
      }
    },
    // logout user;
    async logout(context)
    {
      context.state.authIsReady = false;
      await auth.signOut();
      context.commit('setUser', null);
    }
  },
  modules: {
  }
})
